import { Button, ButtonProps, Flow, Icon, Text } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { useUrlQueryParams } from 'hooks/useUrlQueryParams'
import { useHistory } from 'react-router'

import { BackToOriginUrlParams } from './backToOriginButton-model'
import { getBackToOriginLabel, isBackToOriginKeyEnabled } from './backToOriginButton-utils'

export type BackToOriginButtonProps = Pick<ButtonProps, 'kind' | 'skin' | 'size' | 'style'>

export function BackToOriginButton(props: Readonly<BackToOriginButtonProps>) {
  const { kind = 'primary', skin = 'outline', size = 'small', style } = props

  const history = useHistory()
  const flags = useFlags()
  const { backToOriginUrl, backToOriginKey } = useUrlQueryParams<BackToOriginUrlParams>()

  if (!backToOriginUrl || !isBackToOriginKeyEnabled(flags, backToOriginKey)) return null

  const handleClick = () => history.push(backToOriginUrl)

  return (
    <Button kind={kind} skin={skin} size={size} style={style} onClick={handleClick}>
      <Flow direction='horizontal' alignItems='center' gap={0.5}>
        <Icon icon='angleLeft' />
        <Text color='inherit'>{getBackToOriginLabel(backToOriginKey)}</Text>
      </Flow>
    </Button>
  )
}
